export default {
  gamesLogs: {},
  referralPayments: [],
  bankActivity: []
}
